const isDevelopmentRuntimeModule = (value) => {
  const pathname = value.split('?', 1)[0];
  return pathname === '/sockjs-node' || pathname === '/@vite/client' || pathname === '/@react-refresh';
};

export const normalizeAppDeploymentUrl = (value, baseUrl) => {
  if (typeof value !== 'string' || value.trim() === '') return '';
  try {
    return new URL(value, baseUrl).href;
  } catch {
    return '';
  }
};

export const parseDeployedAppEntryUrl = ({ html, baseUrl, DOMParserClass }) => {
  if (typeof html !== 'string' || typeof DOMParserClass !== 'function') return '';
  const document = new DOMParserClass().parseFromString(html, 'text/html');
  const sources = Array.from(document.querySelectorAll('script[src]'))
    .map((script) => script.getAttribute('src'))
    .filter((source) => typeof source === 'string' && !isDevelopmentRuntimeModule(source));
  const entrySrc = sources.find((source) => /\/static\/js\/main\.[^/]+\.js(?:\?|$)/.test(source))
    || sources.find((source) => /\.(?:m?js)(?:\?|$)/.test(source));
  return normalizeAppDeploymentUrl(entrySrc, baseUrl);
};

export const parseAppDeploymentReloadBudget = (value) => {
  if (typeof value !== 'string' || value === '') return { used: 0 };
  try {
    const parsed = JSON.parse(value);
    return { used: Number.isSafeInteger(parsed?.used) && parsed.used > 0 ? parsed.used : 0 };
  } catch {
    return { used: 0 };
  }
};
